@use "../../../../../styles/Constants.scss" as Constants;

.phoneInputsContainer {
	display: flex;
	justify-content: center;
	align-items: center;
}

.smsConsentContainer {
	margin-bottom: Constants.$val-spacing-s;
}